import { Directive, ElementRef, HostListener, inject, input, output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Subject, throttleTime } from 'rxjs';

@Directive({
  selector: '[mdwScrollIsNearEdge]',
  standalone: true,
})
export class MdwScrollIsNearEdge {
  private readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef<HTMLElement>);

  public readonly edgeToCheck = input<'top' | 'bottom' | 'both'>('bottom');
  public readonly edgeOffset = input<number>(150);

  public readonly nearBottomEdge = output<void>();
  public readonly nearTopEdge = output<void>();

  private readonly scrollSubject$ = new Subject<void>();

  public constructor() {
    this.scrollSubject$
      .pipe(throttleTime(100, undefined, { leading: true, trailing: true }), takeUntilDestroyed())
      .subscribe(() => {
        const scrollContainer = this.elementRef.nativeElement;

        const scrollTop = scrollContainer.scrollTop;
        const scrollHeight = scrollContainer.scrollHeight;
        const clientHeight = scrollContainer.clientHeight;

        const isNearTopEdge = scrollTop <= this.edgeOffset();
        const isNearBottomEdge = scrollHeight - (scrollTop + clientHeight) <= this.edgeOffset();
        const edgeToCheck = this.edgeToCheck();

        if (edgeToCheck === 'both' || edgeToCheck === 'top') {
          if (isNearTopEdge) {
            this.nearTopEdge.emit();
          }
        }

        if (edgeToCheck === 'both' || edgeToCheck === 'bottom') {
          if (isNearBottomEdge) {
            this.nearBottomEdge.emit();
          }
        }
      });
  }

  @HostListener('scroll')
  public scroll() {
    this.scrollSubject$.next();
  }
}
